import { languageOptions } from '../config/constants';
import CurrentUserResource from '../resources/Auth/CurrentUser';

let useLocale = () => {
  let [currentUser] = CurrentUserResource.useLoadable();
  let languageKey =
    (currentUser?.prefersLanguageKey as keyof typeof languageOptions) ||
    languageOptions.english.key;

  return languageOptions[languageKey].locale;
};

export default useLocale;